import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import { useSchool } from '../contexts/SchoolContext';
import './Header.css';

const Header = () => {
  const { settings } = useSchool();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo" onClick={closeMenu}>
            <img src="/logo.png" alt="KS Montessori & Secondary School: home" className="logo-image" />
          </Link>

          <nav id="site-nav" aria-label="Main" className={`nav ${isMenuOpen ? 'active' : ''}`}>
            <NavLink to="/" onClick={closeMenu} end>Home</NavLink>
            <NavLink to="/about" onClick={closeMenu}>About</NavLink>
            <NavLink to="/programs" onClick={closeMenu}>Programs</NavLink>
            {/* Shown only once the school has supplied the content. */}
            {settings.facilities?.length > 0 && <NavLink to="/facilities" onClick={closeMenu}>Facilities</NavLink>}
            <NavLink to="/admissions" onClick={closeMenu}>Admissions</NavLink>
            <NavLink to="/gallery" onClick={closeMenu}>Gallery</NavLink>
            {settings.faqs?.length > 0 && <NavLink to="/faq" onClick={closeMenu}>FAQ</NavLink>}
            <NavLink to="/contact" onClick={closeMenu}>Contact</NavLink>
          </nav>

          <button
            type="button"
            className="menu-toggle"
            onClick={toggleMenu}
            aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={isMenuOpen}
            aria-controls="site-nav"
          >
            {isMenuOpen ? <FaTimes aria-hidden="true" /> : <FaBars aria-hidden="true" />}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
